import { render, staticRenderFns } from "./table.vue?vue&type=template&id=4671bed0&scoped=true&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/table/_table.scss?vue&type=style&index=0&id=4671bed0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4671bed0",
  null
  
)

export default component.exports